/* eslint-disable
    no-param-reassign,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const co = require('co');

const deps = ['bench.main-app', require('angular-ui-router'), require('ui/web/detailsBar').name];

module.exports = angular
  .module('bench.app.mainapp.categorizer.rule', deps)

  .config(($stateProvider, MainAppConfig) =>
    $stateProvider.state('bench.categorizer.rule', {
      url: '/rule/{ruleId:[0-9]*}',
      onEnter(uiStateConfig) {
        return (uiStateConfig.detailsBar = true);
      },
      onExit(uiStateConfig) {
        return (uiStateConfig.detailsBar = false);
      },
      views: {
        'details-bar@bench.categorizer': {
          controller(User, $stateParams, _rules) {
            this.rulesId = _rules.$storeId();
            this.id = $stateParams.ruleId;

            return this;
          },
          controllerAs: 'vm',
          template: `\
<bl-details-bar>
  <bl-categorizer-rule-input
    rules-id="{{vm.rulesId}}"
    rule-id="vm.id">
  </bl-categorizer-rule-input>
</bl-details-bar>\
`,
        },
      },
    }),
  );
